// @flow

import React, { Component } from "react";
import { noop } from "lodash";
import type { NullaryFn, BinaryFn } from "@tvg/types/Functional";
import useFakeInput from "@tvg/utils/useFakeInput";
import ModalV2 from "../../_templates/ModalV2";
import CustomAmount from "../../_molecule/CustomAmount";
import AmountSelector from "../../_molecule/AmountSelector";
import BetAmountContainer from "./styled-components";

type Props = {
  selectedBetAmount: number,
  onChangeBetAmount: BinaryFn<number, boolean, mixed>,
  onCloseCustomAmountModal: NullaryFn<mixed>,
  betAmounts: Array<number>,
  hasOtherAmount: boolean,
  minimumAmount: number,
  modalType: "bottom" | "fade",
  inIosAppTablet: boolean
};

type State = {
  selectedBetAmount: number,
  isModalShown: boolean
};

export default class BetAmount extends Component<Props, State> {
  static defaultProps = {
    selectedBetAmount: 0,
    onChangeBetAmount: noop,
    onCloseCustomAmountModal: noop,
    betAmounts: [],
    hasOtherAmount: false,
    minimumAmount: 0.1,
    modalType: "bottom",
    inIosAppTablet: false
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedBetAmount: this.props.selectedBetAmount,
      isModalShown: false
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.selectedBetAmount !== this.props.selectedBetAmount) {
      this.setState({
        selectedBetAmount: nextProps.selectedBetAmount
      });
    }
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return (
      nextProps.selectedBetAmount !== this.props.selectedBetAmount ||
      nextProps.betAmounts.length !== this.props.betAmounts.length ||
      nextProps.hasOtherAmount !== this.props.hasOtherAmount ||
      nextProps.minimumAmount !== this.props.minimumAmount ||
      nextState.selectedBetAmount !== this.state.selectedBetAmount ||
      nextState.isModalShown !== this.state.isModalShown
    );
  }

  onCloseModal = () => {
    this.setState({
      isModalShown: false
    });

    this.props.onCloseCustomAmountModal();
  };

  onOpenModal = () => {
    if (!this.props.inIosAppTablet) {
      const elem = document.getElementById("customAmountInputId");
      if (elem) {
        // $FlowBug
        elem.focus();
        // $FlowBug
        setTimeout(() => elem.setSelectionRange(100, 100), 0); // this will throw the cursor to the end of the input
      }
    }
  };

  onChange = (value: number) => {
    if (value > 0) {
      this.setState({
        selectedBetAmount: value
      });
      this.props.onChangeBetAmount(value, false);
    } else {
      this.setState({
        isModalShown: true
      });
    }
  };

  updateBetAmount = (value: number) => {
    // Hack for iOSApp in tablet when closing amount modal to fix the layout issues with the keyboard
    if (this.props.inIosAppTablet) {
      useFakeInput();
    }

    this.props.onChangeBetAmount(value, true);
    this.setState({
      selectedBetAmount: value,
      isModalShown: false
    });
  };

  render() {
    const baseProps = {
      title: "Custom Amount",
      animation: this.props.modalType,
      isOpen: this.state.isModalShown,
      onClose: this.onCloseModal,
      onOpen: this.onOpenModal,
      qaLabel: "modal-customAmount",
      isFullHeight: false,
      useFakeInput: this.props.inIosAppTablet
    };

    const props =
      this.props.modalType === "bottom"
        ? baseProps
        : { ...baseProps, isFullWidth: false, offsetTop: 0 };

    return (
      <BetAmountContainer>
        <AmountSelector
          selectedBetAmount={this.state.selectedBetAmount}
          onChangeBetAmount={this.onChange}
          betAmounts={this.props.betAmounts}
          hasOtherAmount={this.props.hasOtherAmount}
        />
        <ModalV2 {...props}>
          {
            /* istanbul ignore next */
            () => (
              <CustomAmount
                minimumAmount={this.props.minimumAmount}
                onUpdateBetAmount={this.updateBetAmount}
              />
            )
          }
        </ModalV2>
      </BetAmountContainer>
    );
  }
}
